export const lightTheme = {
  background: "#FFF",
  bgHover: "#F5F8FA",
  primaryColor: "#000",
  accentColor: "#007BFF",
  textPrimary: "rgb(85,75,85)",
  overlay: "rgba(147, 149, 150, 0.4)",
  font: "Montserrat",
};
